import { render, staticRenderFns } from "./UploadPendingMedicalReport.vue?vue&type=template&id=34dbe6d0"
import script from "./UploadPendingMedicalReport.vue?vue&type=script&lang=js"
export * from "./UploadPendingMedicalReport.vue?vue&type=script&lang=js"
import style0 from "./UploadPendingMedicalReport.vue?vue&type=style&index=0&id=34dbe6d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports